// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__8Zr5n","footer":"Form_footer__1T3p0"};